<script setup lang="ts">
import LeTooltip from "@dsk/components/LeTooltip.vue";
import { computed } from "vue";

import type { Dictionary } from "@/types";

const props = defineProps<{
  dictionary: Dictionary;
  size: "small" | "medium" | "large";
  withTooltip?: boolean;
  withSubtitle?: boolean;
}>();

const style = computed<string>(() =>
  props.dictionary.brandColor ? `background-color: #${props.dictionary.brandColor}` : ""
);

const tooltip = computed<string | undefined>(() => {
  if (props.withTooltip) {
    return props.dictionary.title;
  }

  return undefined;
});
</script>

<template>
  <div>
    <LeTooltip :text="tooltip" :margin-bottom="4">
      <span class="le-dictionary-cover" :class="`le-dictionary-cover--${props.size}`">
        <span class="le-dictionary-cover__content" :style="style">
          <span
            v-if="props.dictionary.publisherLetter"
            class="le-dictionary-cover__letter"
            :class="`le-dictionary-cover__letter--${props.size}`"
          >
            {{ props.dictionary.publisherLetter }}
          </span>
          <span v-if="props.withSubtitle && props.dictionary.subtitle" class="le-dictionary-cover__subtitle">
            {{ props.dictionary.subtitle }}
          </span>
        </span>
      </span>
    </LeTooltip>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-dictionary-cover {
  display: block;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);

  &--small {
    width: 20px;
    height: 30px;
  }

  &--medium {
    width: 24px;
    height: 36px;
  }

  &--large {
    width: 30px;
    height: 44px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #cad5d1;
  }

  &__letter,
  &__subtitle {
    color: @colors[@neutrals][100];
    font-family: @font-family-body;
    user-select: none;
  }

  &__letter {
    display: flex;
    align-items: center;
    font-weight: 600;

    &--small {
      height: 18px;
      font-size: 12px;
    }

    &--medium {
      height: 22px;
      font-size: 14px;
    }

    &--large {
      height: 28px;
      font-size: 16px;
    }
  }

  &__subtitle {
    font-size: 8px;
    font-weight: 700;
  }
}
</style>
